<template>
  <div style="width: 700px;">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div slot="header" class="clearfix">
            <span>报价器-王牌竞速</span>
          </div>
          <el-tabs v-model="activeType" type="card" @tab-click="tabClick">
            <el-tab-pane label="代练" name="dlDan">

            </el-tab-pane>
            <div>
              <el-row>
                <el-col :span="12">
                  <dan v-for="(item,index) in dans"
                       :key="index"
                       :data="item"
                       :selectedDans="selectedDans"
                       @selected="handleSelected"/>
                </el-col>
                <el-col :span="12">
                  <el-form ref="form" label-width="50px" label-position="left">

                    <el-form-item label="起始" v-if="sortedSelectedDans.length > 0">
                        <span v-if="sortedSelectedDans[0].dan != '传奇'" class="dan-desc">
                          {{sortedSelectedDans[0].label}}

                        </span>
                      <span v-if="sortedSelectedDans[0].dan === '传奇'" class="dan-desc">
                          {{sortedSelectedDans[0].label}}
                          <el-input-number size="mini" v-model="fromPoint" :min="0" style="width: 100px;"></el-input-number> 星
                        </span>
                    </el-form-item>
                    <el-form-item label="结束" v-if="sortedSelectedDans.length > 0">
                      <div v-if="sortedSelectedDans.length>1">
                              <span v-if="sortedSelectedDans[1].dan != '传奇'" class="dan-desc">
                          {{sortedSelectedDans[1].label}}
                        </span>
                        <span v-if="sortedSelectedDans[1].dan === '传奇'" class="dan-desc">
                          {{sortedSelectedDans[1].label}}
                            <el-input-number size="mini" v-model="toPoint" :min="0" style="width: 100px;"></el-input-number> 星
                        </span>
                      </div>
                      <div v-else-if="sortedSelectedDans.length==1">
                              <span v-if="sortedSelectedDans[0].dan != '传奇'" class="dan-desc">
                          {{sortedSelectedDans[0].label}}
                        </span>
                        <span v-if="sortedSelectedDans[0].dan === '传奇'" class="dan-desc">
                          {{sortedSelectedDans[0].label}}
                            <el-input-number size="mini" v-model="toPoint" :min="0" style="width: 100px;"></el-input-number> 星
                        </span>
                      </div>
                    </el-form-item>
                    <el-form-item label="折扣">
                      <el-radio-group v-model="discount" size="mini">
                        <el-radio-button border
                                         v-for="(item, index) in discounts" :key="index"
                                         :label="item.discount">{{item.name}}
                        </el-radio-button>
                      </el-radio-group>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </el-tabs>
          <div>
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="genPrice" style="margin-left: 5px" class="btnGen" id="btnGen">生成报价
                  </el-button>
                  <el-button id="btnCopy" v-clipboard:copy="content" v-clipboard:success="onCopy"
                             v-clipboard:error="onError" ref="btnCopy">复制报价
                  </el-button>
                  <el-button @click="reset" id="btnReset">重置查询</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content"
                          :autosize="{ minRows: 3, maxRows: 10}"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div></div>
  </div>
</template>

<script>
  import Dan from '../components/wyRaceDan'
  import Star from '../components/star/Star'

  export default {
    name: 'wyrace',
    components: { Star, Dan },
    data () {
      return {
        gameId: 90,
        zone:'ANDRIOD',
        server:'QQ',
        dans: this.$store.state.wyRaceDans,
        lolPositionDans: [],
        selectedDans: [],
        selectedPoDans: [],
        rate: 0,
        toRate: 0,
        victorypoints: [],
        startStarCount: 1,
        endStarCount: 1,
        showEstimateTime: true,
        content: '',
        activeType: 'dlDan',
        prompt: true,
        fromPoint: 1,
        toPoint: 1,
        isVictoryPoint: false,
        defaultCount: 1,
        discount:'1',
        discounts:[],
        pricingTypeId:1,
        pricingId: 'GOK_LEVELING',
        discountType:'NORMAL'
      }
    },
    mounted () {
      this.getDiscount()
      this.loadVictorypoint()
      //this.loadQuoterTextFormat()
      this.enterKeyup()
    },
    computed: {
      sortedSelectedDans () {
        let target = []
        this.selectedDans = this._.orderBy(this.selectedDans, ['id', 'level'], ['asc', 'asc'])
        this.defaultCount = 1
        Object.assign(target, this.selectedDans)
        target.sort((x, y) => {
          let xDanIndex = this.dans.findIndex((i) => {
            return i.name === x.dan
          })
          let yDanIndex = this.dans.findIndex((i) => {
            return i.name === y.dan
          })
          return xDanIndex - yDanIndex
        })
        this.isVictoryPoint = this.selectedDans.find(item => {
          if (item.isVictoryPoint) {
            return true
          } else {
            return false
          }

        })
        if (this.selectedDans.length == 1) {
          this.selectedDans.push(this.selectedDans[0])
        }
        return target
      }
    },
    methods: {
      loadVictorypoint () {
        let url = '/api/lol/victorypoint'
        this.$http.get(url).then(res => {

          if (res.data != null) {
            this.victorypoints = res.data
            if (this.victorypoints.length > 0) {
              this.victorypointId = this.victorypoints[0].rate
            }
          }
        })
      },
      loadQuoterTextFormat () {
        let url = '/api/company/format?gameId=' + this.gameId + '&pricingType=GOK_LEVELING'
        this.$http.get(url).then(res => {
          let data = res.data

          if (data != null) {
            this.showEstimateTime = data.showEstimateTime
          }
        })
      },
      handleSelected (value) {
        let index = this.selectedDans.findIndex((x) => {

          return x.dan === value.dan && x.subDan === value.subDan && x.label === value.label
        })

        if (index === -1) {
          if (this.selectedDans.length === 2) {
            this.selectedDans.splice(0, 1)
          }
          this.selectedDans.push(value)
        } else {
          this.selectedDans.splice(index, 1)
        }
      },
      handleSelectedPo (value) {
        this.selectedPoDans = []
        this.selectedPoDans.push(value)
      },
      formatSubDan (subDan) {
        if (subDan === 'A' || subDan === 'B') {
          subDan = ''
        }
        return subDan
      },
      genPrice (event) {
        let that = this
        that.gokDanPrice()
      },
      // 代练报价
      gokDanPrice () {
        if (this.sortedSelectedDans.length == 0) {
          this.$message('请选择段位！')
          return false
        }
        let thatEndDan = 0
        let startDan = this.sortedSelectedDans[0].label

        if (this.sortedSelectedDans.length == 1) {
          thatEndDan = this.sortedSelectedDans[0].label
        } else {
          thatEndDan = this.sortedSelectedDans[1].label
        }
        let data = {
          discount:this.discount,
          discountType: this.discountType,
          gameId: this.gameId,
          fromDan: startDan,
          toDan: thatEndDan,
          zone:this.zone,
          server: this.server,
          pricingTypeId:this.pricingTypeId,
          fromPoint:this.sortedSelectedDans[0].dan=='传奇'?this.fromPoint:0,
          toPoint:this.sortedSelectedDans[1].dan=='传奇'?this.toPoint:0,
        }

        this.$http.post('/api/wyrace/price/dan', data).then((res) => {
          if (res == null) {
            return
          }

          this.content = res.data
          this.doCopy(this.content)
          this.$message('代练报价生成成功！')
        })
      },
      //定位赛报价
      lolPositionDanPrice () {
        if (this.selectedPoDans.length == 0) {
          this.$message('请选择段位！')
          return false
        }
        let thatEndDan = 0
        let startDan = this.selectedPoDans[0].label

        let data = {
          discountType: 'NORMAL',
          fromDan: startDan,
          toDan: startDan,
          fromPoint: 0,
          gameId: this.gameId,
          pricingTypeId: 2,
          server: this.server,
          rate: 1,
          showTime: this.showEstimateTime,
          toPoint: this.toPoint
        }

        this.$http.post('/api/lol/price/position', data).then((res) => {
          if (res == null) {
            return
          }
          this.content = res.data
          this.doCopy(this.content)
          this.$message('代练报价生成成功！')
        })
      },
      // 战力报价
      gokBattlePrice () {
        let that = this
        let from = that.$refs['fromBattle'].fromBattle
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint
        }
        this.$http.post('/api/gok/price/battle', data).then((res) => {
          if (res == null) {
            return
          }

          this.content = res.data
          this.doCopy(this.content)
          this.$message('战力报价生成成功！')
        })
      },
      // 巅峰赛报价
      gokSummitPrice () {
        let that = this
        let from = that.$refs['fromSummit'].fromSummit
        let data = {
          fromPoint: from.fromPoint,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint
        }
        this.$http.post('/api/gok/price/summit', data).then((res) => {
          if (res == null) {
            return
          }

          this.content = res.data
          this.doCopy(this.content)
          this.$message('巅峰报价生成成功！')

        })
      },
      //初始化
      reset () {
        let that = this
        this.selectedDans = []
        this.startStarCount = 1
        this.endStarCount = 1
        this.zone = 'ANDRIOD'
        this.server = 'QQ'
        this.fromPoint=0
        this.toPoint=0
        this.$message('重置成功')
      },
      onCopy (e) {
        this.$message('内容已复制到剪切板！')
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message('抱歉，您的浏览器不支持！')
      },
      doCopy (e) {
        let that = this
        that.$copyText(this.content).then(function (e) {
          that.$message('内容已复制到剪切板')

        }, function (e) {
          if (that.prompt) {
            that.prompt = false
            that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！')
          }

        })
      },
      enterKeyupDestroyed () {
        document.removeEventListener('keyup', this.enterKey)
      },
      enterKeyup () {
        document.addEventListener('keyup', this.enterKey)
      },
      enterKey (event) {
        const componentName = this.$options.name

        if (componentName == 'wyrace') {
          const code = event.keyCode
            ? event.keyCode
            : event.which
              ? event.which
              : event.charCode

          if (code == 32) {
            this.genPrice()
          } else if (code == 13) {
            this.doCopy()
          }
        }
      },
      showMessage (msg, duration) {
        let that = this
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration
        })
      },
      startStarChange (val) {
        this.startStarCount = val
        this.rate = 0
      },
      endStarChange (val) {
        this.endStarCount = val
        this.toRate = 0
      },
      startVictoryPoint (val) {
        this.rate = val
        this.startStarCount = 0
      },
      endVictoryPoint (val) {
        this.toRate = val
        this.endStarCount = 0
      },
      //获取折扣设置
      getDiscount(){
        let that=this
        that.discounts=[]
        that.discount=null
        axios.get('/api/company/discount',{params:{gameId:that.gameId,pricingType:that.pricingId}}).then(res=>{
          if(res!=null){
            that.discounts=res.data
          }
          that.discounts.unshift({name:'不打折',discount: '1'})
          that.discount='1'
        })
      },
      tabClick(tab, event){
        if(tab.name=='dlDan'){
          this.reset()
          this.content=''
          this.pricingTypeId=1
        }else{
          this.reset()
          this.content=''
          this.pricingTypeId=2
        }
      }
    },
    destroyed () {
      let that = this
      that.$message.closeAll()
      // 销毁enter事件
      this.enterKeyupDestroyed()
    },
    beforeDestroy () {
      // 销毁enter事件
      this.enterKeyupDestroyed()
    },
    //整单优惠报价
    gokTotalPrice () {
      let that = this
      this.discountType = 'TOTAL'
      if (that.activeType === 'dlDan' || that.activeType === 'PartnerDan') {
        that.gokDanPrice()
      } else if (that.activeType === 'Battle') {
        that.gokBattlePrice()
      } else if (that.activeType === 'Summit') {
        that.gokSummitPrice()
      }
    },
    tabClick(){

    }

  }
</script>

<style lang="stylus" scoped>
  .desc_text {
    height 40px;
    line-height 40px;

  }
</style>
